module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.confs.filters
    }
  }, [_vm._l((_vm.confs.query), function(item) {
    return _c('el-form-item', [(item.elType == 'el-input') ? _c('el-input', {
      attrs: {
        "placeholder": item.title
      },
      model: {
        value: (_vm.confs.filters[item.key]),
        callback: function($$v) {
          _vm.$set(_vm.confs.filters, item.key, $$v)
        },
        expression: "confs.filters[item.key]"
      }
    }) : (item.elType == 'el-select') ? _c('el-select', {
      staticClass: "h-m-select",
      attrs: {
        "placeholder": item.title
      },
      model: {
        value: (_vm.confs.filters[item.key]),
        callback: function($$v) {
          _vm.$set(_vm.confs.filters, item.key, $$v)
        },
        expression: "confs.filters[item.key]"
      }
    }, _vm._l((_vm.confs.selectList[item.listkey].data), function(selectItem) {
      return _c('el-option', {
        key: selectItem[item.opkey],
        attrs: {
          "label": selectItem[item.opval],
          "value": selectItem[item.opkey]
        }
      })
    }), 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getLists
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "info",
      "plain": ""
    },
    on: {
      "click": _vm.cleanQuery
    }
  }, [_vm._v("清空条件")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-document-add"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 2)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "data": _vm.datalist,
      "border": "",
      "stripe": "",
      "highlight-current-row": "",
      "height": "500",
      "cell-class-name": "cell-content-top"
    },
    on: {
      "row-click": _vm.rowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "margin-bottom": "8px"
          }
        }, [(scope.row.status <= 2) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "plain": "",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.addNums(scope.$index, scope.row)
            }
          }
        }, [_vm._v("添加线索")]) : _vm._e()], 1), _vm._v(" "), (scope.row.status == 2 || scope.row.status == 4) ? _c('div', {
          staticStyle: {
            "margin-bottom": "8px"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "success",
            "icon": "el-icon-video-play",
            "plain": "",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.uptStat(scope.row, '3')
            }
          }
        }, [_vm._v("开始")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('div', {
          staticStyle: {
            "margin-bottom": "8px"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "warning",
            "icon": "el-icon-video-pause",
            "plain": "",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.uptStat(scope.row, '4')
            }
          }
        }, [_vm._v("暂停")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
          staticStyle: {
            "margin-bottom": "8px"
          }
        }, [(scope.row.called_counts <= 0) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "icon": "el-icon-delete",
            "plain": "",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "任务信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('font', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(_vm._s(scope.row.entime))]), _c('br'), _vm._v(" "), _c('font', {
          staticStyle: {
            "font-size": "13px",
            "color": "green"
          }
        }, [_vm._v(_vm._s(scope.row.name))]), _c('br'), _vm._v(" "), _c('font', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(_vm._s(_vm.showLabs(scope.row.company_code, 'company', 'code', 'name')))]), _c('br'), _vm._v(" "), (scope.row.status == 1) ? _c('font', {
          staticStyle: {
            "font-size": "13px",
            "color": "#2b85e3"
          }
        }, [_vm._v(_vm._s(_vm.showLabs(scope.row.status, 'status', 'keystr', 'val')))]) : (scope.row.status == 2) ? _c('font', {
          staticStyle: {
            "font-size": "13px",
            "color": "#ea8d00"
          }
        }, [_vm._v(_vm._s(_vm.showLabs(scope.row.status, 'status', 'keystr', 'val')))]) : (scope.row.status == 3) ? _c('font', {
          staticStyle: {
            "font-size": "13px",
            "color": "#15dcb3"
          }
        }, [_vm._v(_vm._s(_vm.showLabs(scope.row.status, 'status', 'keystr', 'val')))]) : (scope.row.status == 4) ? _c('font', {
          staticStyle: {
            "font-size": "13px",
            "color": "#f80909"
          }
        }, [_vm._v(_vm._s(_vm.showLabs(scope.row.status, 'status', 'keystr', 'val')))]) : (scope.row.status == 5) ? _c('font', {
          staticStyle: {
            "font-size": "13px",
            "color": "green"
          }
        }, [_vm._v(_vm._s(_vm.showLabs(scope.row.status, 'status', 'keystr', 'val')))]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "基本配置"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('font', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(_vm._s(scope.row.start_time) + "--" + _vm._s(scope.row.end_time))]), _c('br'), _vm._v(" "), _vm._l((scope.row.call_nums), function(ins, index) {
          return _c('div', {
            staticClass: "var-text"
          }, [_vm._v(" \r\n\t\t\t\t\t\t\t主叫" + _vm._s(index + 1) + ":"), _c('font', {
            staticStyle: {
              "font-weight": "bold",
              "color": "#a16408",
              "text-decoration": "underline"
            }
          }, [_vm._v(_vm._s(ins.nm))])], 1)
        }), _vm._v(" "), _c('hr', {
          attrs: {
            "size": "1"
          }
        }), _vm._v(" "), _vm._l((scope.row.variables), function(ins, index) {
          return _c('div', {
            staticClass: "var-text"
          }, [_vm._v(" \r\n\t\t\t\t\t\t\t设置:" + _vm._s(ins.kn) + " = "), _c('font', {
            staticStyle: {
              "font-weight": "bold",
              "color": "#1b79dc",
              "text-decoration": "underline"
            }
          }, [_vm._v(_vm._s(ins.val))])], 1)
        })], 2)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "线索数据"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\r\n\t\t\t\t\t线索:" + _vm._s(scope.row.num_counts) + "  \r\n\t\t\t\t\t"), _c('div', {
          staticStyle: {
            "margin-bottom": "8px"
          }
        }, [(scope.row.status <= 2) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "plain": "",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.loadFileNums(scope.$index, scope.row)
            }
          }
        }, [_vm._v("导入线索")]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v("\r\n\t\t\t\t\t完成:" + _vm._s(scope.row.called_counts) + "  时长:" + _vm._s(scope.row.call_mins)), _c('br'), _vm._v("\r\n\t\t\t\t\t成功:" + _vm._s(scope.row.called_ok) + "  失败:" + _vm._s(scope.row.called_err) + "\r\n\t\t\t\t")]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 21
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": _vm.pagesize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": _vm.editformtitle,
      "visible": _vm.editFormVisible,
      "before-close": _vm.clickClose,
      "size": "50%",
      "with-header": false,
      "direction": "rtl"
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.formRules,
      "label-width": "180px"
    }
  }, [_c('el-container', {
    staticStyle: {
      "min-height": "100vh"
    }
  }, [_c('el-main', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%",
      "display": "inline-block",
      "margin": "0 auto",
      "margin-bottom": "25px"
    }
  }, [_c('el-steps', {
    attrs: {
      "active": _vm.taskActive,
      "finish-status": "success"
    }
  }, [_c('el-step', {
    attrs: {
      "title": "选择任务"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "选择号码"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "选择话术",
      "prop": "call_script_id"
    }
  }, [_c('el-select', {
    staticClass: "h-m-select",
    attrs: {
      "filterable": "",
      "placeholder": "请输入/请选择"
    },
    on: {
      "change": _vm.selectScript
    },
    model: {
      value: (_vm.editForm.call_script_id),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "call_script_id", $$v)
      },
      expression: "editForm.call_script_id"
    }
  }, _vm._l((_vm.strpitList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name
      },
      model: {
        value: (item.id),
        callback: function($$v) {
          _vm.$set(item, "id", $$v)
        },
        expression: "item.id"
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "任务名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入名称"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "开始时间",
      "prop": "start_time"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择开始日期时间"
    },
    model: {
      value: (_vm.editForm.start_time),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "start_time", $$v)
      },
      expression: "editForm.start_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "结束时间",
      "prop": "start_time"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择开始日期时间"
    },
    model: {
      value: (_vm.editForm.end_time),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "end_time", $$v)
      },
      expression: "editForm.end_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主叫"
    }
  }, _vm._l((_vm.editForm.call_nums), function(ins, index) {
    return _c('div', {
      staticClass: "var-text"
    }, [_vm._v(" \r\n\t\t\t\t\t\t\t\t主叫" + _vm._s(index + 1) + ":"), _c('font', {
      staticStyle: {
        "font-weight": "bold",
        "color": "#a16408",
        "text-decoration": "underline"
      }
    }, [_vm._v(_vm._s(ins.nm))])], 1)
  }), 0), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "信息"
    }
  }, _vm._l((_vm.editForm.variables), function(ins, index) {
    return _c('div', {
      staticClass: "var-text"
    }, [_vm._v(" \r\n\t\t\t\t\t\t\t\t设置:" + _vm._s(ins.kn) + " = "), _c('font', {
      staticStyle: {
        "font-weight": "bold",
        "color": "#1b79dc",
        "text-decoration": "underline"
      }
    }, [_vm._v(_vm._s(ins.val))])], 1)
  }), 0)], 1), _vm._v(" "), _c('el-footer', [_c('div', {
    staticClass: "to-right"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": _vm.editformtitle,
      "visible": _vm.addFormVisible,
      "before-close": _vm.clickCloseQueryPhones,
      "size": "50%",
      "direction": "rtl"
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-container', {
    staticStyle: {
      "min-height": "100vh"
    }
  }, [_c('el-main', {
    staticStyle: {
      "padding": "10px",
      "margin-top": "10px"
    }
  }, [_c('el-form', {
    ref: "queryPhones",
    attrs: {
      "inline": true,
      "model": _vm.queryPhones
    }
  }, [_c('el-form-item', [_c('el-date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择开始日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.queryPhones.entimes),
      callback: function($$v) {
        _vm.$set(_vm.queryPhones, "entimes", $$v)
      },
      expression: "queryPhones.entimes"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择结束日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.queryPhones.entimee),
      callback: function($$v) {
        _vm.$set(_vm.queryPhones, "entimee", $$v)
      },
      expression: "queryPhones.entimee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请输入导入批次"
    },
    model: {
      value: (_vm.queryPhones.groups),
      callback: function($$v) {
        _vm.$set(_vm.queryPhones, "groups", $$v)
      },
      expression: "queryPhones.groups"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getPhonesLists
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.cleanQueryPhone
    }
  }, [_vm._v("清空")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editAddSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("添加选中的线索")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editAddQuerySubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("添加条件的线索")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "data": _vm.phonesDatalist,
      "border": "",
      "stripe": "",
      "highlight-current-row": "",
      "height": "450",
      "cell-class-name": "cell-content-top"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "entime",
      "label": "时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "线索",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "groups",
      "label": "批次",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sextype",
      "label": "性别",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\r\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.showLabs(scope.row.sextype, 'sextype', 'keystr', 'val')) + "\r\n\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "age",
      "label": "年龄",
      "width": "110"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 21
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": _vm.pagesize,
      "total": _vm.phonetotal
    },
    on: {
      "current-change": _vm.handleQueryCurrent
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "visible": _vm.showCallListVisble,
      "before-close": _vm.clickCloseCall,
      "size": "55%",
      "direction": "rtl"
    },
    on: {
      "update:visible": function($event) {
        _vm.showCallListVisble = $event
      }
    }
  }, [_c('el-form', {
    ref: "addNumsForm",
    attrs: {
      "model": _vm.addNumsForm,
      "label-width": "150px",
      "rules": _vm.formAddRules,
      "label-width": "180px"
    }
  }, [_c('el-container', {
    staticStyle: {
      "min-height": "100vh"
    }
  }, [_c('el-main', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.callDetailLoading),
      expression: "callDetailLoading"
    }],
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "data": _vm.callDetailList,
      "border": "",
      "stripe": "",
      "highlight-current-row": "",
      "height": "500",
      "cell-class-name": "cell-content-top"
    },
    on: {
      "row-click": _vm.rowDetailClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "线索"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\r\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.showLabs(scope.row.status, 'callStatus', 'keystr', 'val')) + "\r\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "线索状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "font-size": "11px"
          }
        }, [_vm._v(_vm._s(_vm.showLabs(scope.row.job_status, 'calledStatus', 'keystr', 'val')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "use_time",
      "label": "时长秒"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "其他"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.summary), function(ins) {
          return _c('div', {
            staticClass: "var-text"
          }, [_vm._v(" \r\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(ins.key) + "="), _c('font', {
            staticStyle: {
              "font-weight": "bold",
              "color": "#a16408",
              "text-decoration": "underline"
            }
          }, [_vm._v(_vm._s(ins.val))])], 1)
        })
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "visible": _vm.showCallDetailVisble,
      "before-close": _vm.closeShowCall,
      "size": "40%",
      "direction": "rtl"
    },
    on: {
      "update:visible": function($event) {
        _vm.showCallDetailVisble = $event
      }
    }
  }, [_c('el-container', {
    staticStyle: {
      "min-height": "100vh"
    }
  }, [_c('el-main', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, _vm._l((_vm.talk_json), function(o) {
    return _c('div', {
      key: o,
      staticClass: "text item"
    }, [_vm._v("\r\n\t\t\t\t\t\t" + _vm._s(o.speaker) + ":" + _vm._s(o.script) + "\r\n\t\t\t\t\t  ")])
  }), 0)], 1)], 1)], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "visible": _vm.addLoadFileVisble,
      "before-close": _vm.closeAddFile,
      "size": "40%",
      "direction": "rtl"
    },
    on: {
      "update:visible": function($event) {
        _vm.addLoadFileVisble = $event
      }
    }
  }, [_c('el-container', {
    staticStyle: {
      "min-height": "100vh"
    }
  }, [_c('el-main', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": _vm.fileServerPath,
      "multiple": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传cvs且不超过500kb")])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4a924971"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/callsys/taskList.vue
// module id = 648
// module chunks = 1